(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart-drawer"]) return;
  try {
    
  (() => {
    const drawer = document.querySelector('[data-cart]');
    if (!drawer) return;

    // The Section Rendering API needs this section's real id, which Shopify
    // generates. Read it off the wrapper rather than hardcoding it.
    const wrapper = drawer.closest('.shopify-section');
    const sectionId = wrapper ? wrapper.id.replace('shopify-section-', '') : null;

    // Read the duration from CSS so there's only one place to change it.
    const slideMs = (() => {
      const raw = getComputedStyle(drawer).getPropertyValue('--cart-slide').trim();
      const ms = raw.endsWith('ms') ? parseFloat(raw) : parseFloat(raw) * 1000;
      return Number.isFinite(ms) && ms > 0 ? ms : 480;
    })();

    const open = () => { if (!drawer.open) drawer.showModal(); };

    /*
     * Close in two steps: slide out, then close().
     *
     * The tempting version is `transition: display allow-discrete`, which lets
     * CSS defer the display change on its own. It works — until a transition
     * doesn't run, and then the element is left with display:flex and open
     * false, sitting in the page. Measured exactly that.
     *
     * Driving it from here means close() is only ever called once the panel is
     * already off-screen, and the timer guarantees it happens even if
     * transitionend never fires.
     */
    function dismiss() {
      if (!drawer.open || drawer.hasAttribute('data-closing')) return;
      drawer.setAttribute('data-closing', '');

      const finish = () => {
        clearTimeout(timer);
        drawer.removeAttribute('data-closing');
        drawer.close();
      };
      const timer = setTimeout(finish, slideMs + 120);

      drawer.addEventListener('transitionend', (event) => {
        if (event.target === drawer && event.propertyName === 'translate') finish();
      }, { once: true });
    }

    // Escape closes a <dialog> natively and instantly; intercept so it slides.
    drawer.addEventListener('cancel', (event) => { event.preventDefault(); dismiss(); });

    // Replace the drawer's contents with a freshly rendered copy, so totals
    // come from Shopify rather than being recomputed here.
    async function refresh() {
      if (!sectionId) { window.location.href = '/cart'; return; }
      const res = await fetch(`?sections=${encodeURIComponent(sectionId)}`);
      const data = await res.json();
      const html = new DOMParser().parseFromString(data[sectionId], 'text/html');
      const fresh = html.querySelector('[data-cart]');
      if (!fresh) return;

      const wasOpen = drawer.open;
      drawer.innerHTML = fresh.innerHTML;
      if (wasOpen) open();

      // Keep the header badge in step.
      const count = html.querySelector('.cart__count');
      const badge = document.querySelector('.hdr__count');
      const cartLink = document.querySelector('.hdr__cart');
      if (count && cartLink) {
        if (badge) badge.textContent = count.textContent.trim();
        else cartLink.insertAdjacentHTML('beforeend', `<span class="hdr__count" aria-hidden="true">${count.textContent.trim()}</span>`);
      } else if (badge) {
        badge.remove();
      }
    }

    async function post(url, body) {
      drawer.classList.add('cart__busy');
      try {
        const res = await fetch(url, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify(body),
        });
        if (!res.ok) throw new Error(await res.text());
        await refresh();
      } catch (err) {
        // Anything unexpected falls back to the real cart page rather than
        // leaving someone staring at a drawer that silently did nothing.
        console.error('[cart]', err);
        window.location.href = '/cart';
      } finally {
        drawer.classList.remove('cart__busy');
      }
    }

    // Intercept every add-to-bag form. Without this they post normally and
    // land on /cart, which is the correct no-JavaScript behaviour.
    document.addEventListener('submit', (event) => {
      const form = event.target.closest('form[action*="/cart/add"]');
      if (!form) return;
      event.preventDefault();
      const data = new FormData(form);
      open();
      post('/cart/add.js', {
        id: data.get('id'),
        quantity: Number(data.get('quantity') || 1),
      });
    });

    // Quantity and remove, delegated so it survives the innerHTML swap.
    document.addEventListener('click', (event) => {
      const close = event.target.closest('[data-cart-close]');
      if (close) { dismiss(); return; }

      const step = event.target.closest('[data-cart-qty]');
      if (step) {
        post('/cart/change.js', {
          id: step.dataset.cartQty,
          quantity: Number(step.dataset.to),
        });
      }
    });

    // Opening from the header icon rather than navigating to /cart.
    document.querySelector('.hdr__cart')?.addEventListener('click', (event) => {
      event.preventDefault();
      open();
      refresh();
    });

    // Backdrop click closes it — a click landing on the dialog itself is
    // outside the panel, since the panel doesn't fill the viewport.
    drawer.addEventListener('click', (event) => {
      if (event.target === drawer) dismiss();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["contact"] && !Shopify.designMode) return;
  try {
    
  // Quick paths preselect the topic. They're real anchor links, so without
  // this they still take you to the form — the topic just isn't filled in.
  const topicField = document.querySelector('[data-topic-field]');

  if (topicField) {
    document.querySelectorAll('[data-topic]').forEach((link) => {
      link.addEventListener('click', () => {
        const wanted = link.dataset.topic;
        const match = [...topicField.options].find((o) => o.value === wanted);
        if (match) {
          topicField.value = wanted;
          // Announce the change for anyone not watching the select scroll past.
          topicField.dispatchEvent(new Event('change', { bubbles: true }));
        }
      });
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  const header = document.querySelector('[data-hdr]');
  const drawer = document.querySelector('[data-hdr-drawer]');

  // Hairline appears once the page has moved. Passive listener so it never
  // blocks scrolling, and a sentinel would be overkill for one boolean.
  if (header) {
    // A full-bleed hero as the first section means the nav floats over it.
    const hero = document.querySelector('.hero');
    const overlay = !!hero && hero.closest('.shopify-section') === header.closest('.shopify-section')?.nextElementSibling;
    header.toggleAttribute('data-over', overlay);
    header.closest('.shopify-section')?.toggleAttribute('data-over', overlay);

    // Solid once the hero is behind you; a few pixels is enough otherwise.
    const threshold = () => (overlay ? hero.offsetHeight - header.offsetHeight : 4);

    // Keep the iOS status-bar tint matching whatever is directly beneath it.
    const themeMeta = document.querySelector('meta[name="theme-color"]');
    const css = getComputedStyle(document.documentElement);
    const darkTint = css.getPropertyValue('--color-black').trim() || '#151715';
    const lightTint = css.getPropertyValue('--color-chalk').trim() || '#F7F7F3';
    let lastTint = null;

    const setScrolled = () => {
      const scrolled = window.scrollY > threshold();
      header.toggleAttribute('data-scrolled', scrolled);

      // Only write when it actually changes — this runs on every scroll frame.
      const tint = overlay && !scrolled ? darkTint : lightTint;
      if (themeMeta && tint !== lastTint) {
        themeMeta.setAttribute('content', tint);
        lastTint = tint;
      }
    };
    setScrolled();
    window.addEventListener('scroll', setScrolled, { passive: true });
    window.addEventListener('resize', setScrolled, { passive: true });
  }

  if (drawer) {
    document.querySelector('[data-hdr-open]')?.addEventListener('click', () => drawer.showModal());
    document.querySelector('[data-hdr-close]')?.addEventListener('click', () => drawer.close());

    // Bind to every link, not just in-page anchors — nav hrefs are paths like
    // /collections/recovery, which an [href^="#"] selector would miss.
    drawer.querySelectorAll('a').forEach((a) => a.addEventListener('click', () => drawer.close()));

    // Clicking the backdrop closes it. The dialog element itself fills only
    // part of the viewport, so a click landing on <dialog> is a backdrop click.
    drawer.addEventListener('click', (event) => {
      if (event.target === drawer) drawer.close();
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["process"] && !Shopify.designMode) return;
  try {
    
  /*
   * Runs the selection through the words: try, miss, think, again — then rests
   * a beat longer on send before starting over, because the send is the payoff
   * and giving it the same 0.5s as the attempts flattens the whole point.
   *
   * Driven from script rather than CSS keyframes because the keyframe
   * percentages would have to be recomputed from the number of steps, and the
   * steps are editable blocks.
   */
  document.querySelectorAll('[data-proc-steps]').forEach((list) => {
    const steps = [...list.querySelectorAll('.proc__step')];
    if (steps.length < 2) return;

    const stepMs = Number(list.dataset.step) || 500;
    const holdMs = Number(list.dataset.hold) || 1400;
    const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');

    let index = 0;
    let timer = null;
    let onScreen = false;

    function tick() {
      steps.forEach((step, i) => step.classList.toggle('is-on', i === index));
      const isLast = index === steps.length - 1;
      index = (index + 1) % steps.length;
      timer = setTimeout(tick, isLast ? holdMs : stepMs);
    }

    function start() {
      if (timer || reduced.matches || document.hidden || !onScreen) return;
      list.classList.add('is-cycling');
      index = 0;
      tick();
    }

    function stop() {
      clearTimeout(timer);
      timer = null;
      list.classList.remove('is-cycling');
      steps.forEach((step) => step.classList.remove('is-on'));
    }

    // Only while it's actually on screen — no reason to run a timer against a
    // section nobody is looking at.
    new IntersectionObserver(([entry]) => {
      onScreen = entry.isIntersecting;
      onScreen ? start() : stop();
    }, { threshold: 0.35 }).observe(list);

    document.addEventListener('visibilitychange', () => (document.hidden ? stop() : start()));
    reduced.addEventListener('change', () => (reduced.matches ? stop() : start()));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  // Dots track the swipe position on phones. IntersectionObserver rather than a
  // scroll handler so it costs nothing while the strip isn't moving.
  const gallery = document.querySelector('[data-gallery]');
  const dots = document.querySelector('[data-gallery-dots]');

  if (gallery && dots) {
    const shots = [...gallery.querySelectorAll('.pdp__shot')];
    const marks = [...dots.children];

    const observer = new IntersectionObserver(
      (entries) => {
        for (const entry of entries) {
          if (!entry.isIntersecting) continue;
          const i = shots.indexOf(entry.target);
          marks.forEach((m, n) => m.classList.toggle('is-on', n === i));
        }
      },
      { root: gallery, threshold: 0.6 }
    );

    shots.forEach((shot) => observer.observe(shot));
  }

  } catch(e) { console.error(e); }
})();
})();
